import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IResponse } from 'src/app/interface/response';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IUser } from 'src/app/interface/user';

@Injectable({
	providedIn: 'root',
})
export class VerificationService {
	constructor(
		private httpClient: HttpClient
	) { }

	public verify(data: { token?: string; code?: string; }): Observable<IVerifyResponse> {
		return this.httpClient.put<IVerifyResponse>(environment.apiUrl + '/verify', data);
	}

	public sendCode(data: any = null): Observable<any> {
		return this.httpClient
			.post<any>(environment.apiUrl + '/verify/send_code', data);
	}
}

interface IVerifyResponse extends IResponse {
	user?: IUser;
}